import React, { useEffect, useState } from "react";
import BranchInputs from "../../Inputs/BranchInputs/BranchInputs";
import { useDispatch } from "react-redux";
import { deleteBranch, updateBranch } from "../../../redux/branchSlice/branchSlice";
import Swal from "sweetalert2";

export default function UpdateBranch({ branch, onBranchDelete }) {
  const dispatch = useDispatch();

  const [branchData, setBranchData] = useState({
    id: "",
    company_id: "",
    name: "",
    email: "",
    address: "",
    city: "",
    location: "",
    manager_name: "",
    phone: "",
    state: "",
    status: "",
  });

  useEffect(() => {
    if (branch) {
      setBranchData(branch);
    }
  }, [branch]);

  const onInputChange = (id, value) => {
    setBranchData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleForm = (e) => {
    e.preventDefault();
    dispatch(updateBranch({ data: branchData, id: branchData.id }))
      .unwrap()
      .then(() => {
        Swal.fire("تم الحفظ!", "تم تحديث بيانات الفرع بنجاح.", "success");
      })
      .catch((error) => {
        Swal.fire("خطأ!", "فشل في تحديث بيانات الفرع.", "error");
        console.error("Failed to update branch:", error);
      });
  };

  const handleDeleteBranch = async () => {
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: "لا يمكن التراجع عن هذه العملية!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "نعم، احذفه!",
      cancelButtonText: "إلغاء",
    });

    if (result.isConfirmed) {
      try {
        await dispatch(deleteBranch(branchData.id)).unwrap();
        Swal.fire("تم الحذف!", "تم حذف الفرع بنجاح.", "success");
        if (onBranchDelete) {
          onBranchDelete(branchData.id);
        }
      } catch (error) {
        Swal.fire("خطأ!", "فشل في حذف الفرع.", "error");
        console.error("Error deleting branch:", error);
      }
    }
  };

  return (
    <form onSubmit={handleForm}>
      <div className="card pt-5 pb-2 px-3 mb-4">
        <BranchInputs branchData={branchData} onInputChange={onInputChange} />
        <div className="d-flex justify-content-between">
          <button type="submit" className="btn btn-primary">
            <i className="fa fa-save me-1"></i>
            حفظ
          </button>
          <button type="button" onClick={handleDeleteBranch} className="btn btn-outline-danger">
            <i className="fa fa-trash me-1"></i>
            حذف الفرع
          </button>
        </div>
      </div>
    </form>
  );
}
